import React, {Component} from 'react';
import {translate} from 'react-i18next';

import * as moment from 'moment';
import 'moment/locale/de';
import Select2 from 'react-select2-wrapper';

import PageHeader from '../elements/PageHeader';
import SupporterElement from '../elements/tablet/SupporterElement';
import AddSupporterToShift from '../elements/tablet/AddSupporterToShift';

class TabletScreen extends Component {

    constructor(props) {
        super(props);

        this.handleChangeTimeSlot = this.handleChangeTimeSlot.bind(this);
        this.handleChangeRoute = this.handleChangeRoute.bind(this);
        this.handleSelectSupporter = this.handleSelectSupporter.bind(this);
    }

    componentDidMount() {
        this.props.startSync();
        this.syncInterval = setInterval(
            () => this.props.startSync(),
        300000);
    }

    componentWillUnmount() {
        clearInterval(this.syncInterval);
    }

    handleChangeTimeSlot(e) {
        this.props.setTimeSlot(e.target.value);
    }

    handleChangeRoute(e) {
        this.props.setRoute(e.target.value);
    }

    handleSelectSupporter(supporterId, location) {
        this.props.addSupporterToShift(supporterId, location);
    }

    render() {
        const { tabletState, t } = this.props;
        let timeSlot, routes, route, locations;
        {
            if (tabletState.timeSlot && tabletState.data && tabletState.supporters) {
                timeSlot = tabletState.data.filter((el) => el.date === tabletState.timeSlot);
                if(timeSlot && timeSlot.length > 0) {
                    routes = timeSlot[0].routes;
                    if(routes) {
                        route = tabletState.data.filter((el) => el.date === tabletState.timeSlot)[0].routes.filter((el) => el.id === parseInt(tabletState.route))[0];
                        if(route) {
                            locations = tabletState.data.filter((el) => el.date === tabletState.timeSlot)[0].routes.filter((el) => el.id === parseInt(tabletState.route))[0].locations
                        }
                    }
                }
            }
        }

        return (
            <div className="TabletScreen">
                <PageHeader title="Runner-Ansicht" loading={tabletState.syncing}/>
                <div className="row m-t">
                    <div className="col-xs-12">
                        <div className="ibox">
                            <div className="ibox-title">
                                <h4>
                                    Status
                                </h4>
                            </div>
                            <div className="ibox-content">
                                <div className="row">
                                    <div className="col-sm-6 col-lg-3">
                                        Letzte Synchronisation: {tabletState.lastSyncedAt ? moment(tabletState.lastSyncedAt).format('DD.MM.YY, HH:mm:ss') : 'nie'}
                                    </div>
                                    <div className="col-sm-6 col-lg-3">
                                        Letzter Synchronisations-Versuch: {tabletState.lastSyncTry ? moment(tabletState.lastSyncTry).format('DD.MM.YY, HH:mm:ss') : 'nie'}
                                    </div>
                                    <div className="col-sm-6 col-lg-3">
                                        Ungespeicherte Änderungen: {tabletState.actions.length}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row m-t">
                    <div className="col-xs-12">
                        <div className="ibox">
                            <div className="ibox-title">
                                <h4>
                                    Auswahl der Route
                                </h4>
                            </div>
                            <div className="ibox-content">
                                <div className="row">
                                    <div className="col-xs-12">
                                        <div className="form-group">
                                            <label>
                                                Zeit-Slot
                                            </label>
                                            <Select2 data={tabletState.data ? tabletState.data.map((el) => {
                                                return {
                                                    text: moment(el.date).format('DD.MM.YY, HH:mm'), id: el.date
                                                }
                                            }) : []} value={tabletState.timeSlot} onChange={this.handleChangeTimeSlot} name="timeSlot"
                                                     disabled={!tabletState.data}
                                                     options={{placeholder: 'Startzeit wählen', minimumResultsForSearch: Infinity}}
                                                     className="width-100p block"/>
                                        </div>
                                    </div>
                                </div>
                                {tabletState.timeSlot && tabletState.data ? (
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <label>
                                                    Route
                                                </label>
                                                <Select2 data={routes ? routes.map((el) => {
                                                    return {
                                                        text: el.name, id: el.id
                                                    }
                                                }) : []} value={tabletState.route} onChange={this.handleChangeRoute} name="route"
                                                         disabled={!tabletState.timeSlot}
                                                         options={{placeholder: 'Route wählen', minimumResultsForSearch: Infinity}}
                                                         className="width-100p block"/>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                                {tabletState.timeSlot && tabletState.route && tabletState.data && tabletState.supporters ? (
                                    <div className="row">
                                        <div className="col-xs-6 col-md-3">
                                            Wartebereich: <b>{route ? route.waitingSpot : ''}</b>
                                        </div>
                                        <div className="col-xs-6 col-md-3">
                                            Supporter:innen: <b>{locations ? (locations.reduce((a, b) => (a + b.shifts[0].supporters.length), 0)) : ''}/{locations ? (locations.reduce((a, b) => (a + b.shifts[0].slots), 0)) : ''}</b>
                                        </div>
                                    </div>
                                ) : null}
                                {/*
                                    console.log(tabletState.data.filter((el) => el.date === tabletState.timeSlot)[0].routes.filter((el) => el.id === parseInt(tabletState.route)))
                                */}
                            </div>
                        </div>
                    </div>
                </div>
                {tabletState.timeSlot && tabletState.route && tabletState.data && tabletState.supporters ? (
                    locations ? locations.map((location, i) => (
                        <div key={i} className="row m-t">
                            <div className="col-xs-12">
                                <div className="ibox">
                                    <div className="ibox-title">
                                        <h5>
                                            {location.name} {location.equipment && location.equipment.length > 0 ? (<span className="text-muted">({location.equipment})</span>) : null}
                                        </h5>
                                        <div className="ibox-tools">
                                            <AddSupporterToShift supporters={tabletState.supporters} handleSelectSupporter={(supporter) => this.handleSelectSupporter(supporter, location)}/>
                                        </div>
                                    </div>
                                    <div className="ibox-content">
                                        <div className="row">
                                            {(location.description && location.description.length > 0) ? (
                                                <div className="col-md-3">
                                                    <label>Beschreibung</label>
                                                    <div>{location.description}</div>
                                                </div>
                                            ) : null}
                                            {(location.place && location.place.length > 0) ? (
                                                <div className="col-md-3">
                                                    <label>Ortsbeschreibung</label>
                                                    <div>{location.place}</div>
                                                </div>
                                            ) : null}
                                            {(location.contactPerson && location.contactPerson.length > 0) ? (
                                                <div className="col-md-3">
                                                    <label>Kontaktperson</label>
                                                    <div>{location.contactPerson}</div>
                                                </div>
                                            ) : null}
                                            {(location.specialInformation && location.specialInformation.length > 0) ? (
                                                <div className="col-md-3">
                                                    <label>Zusatzinformationen</label>
                                                    <div>{location.specialInformation}</div>
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className="row m-t">
                                            <div className="col-xs-12">
                                                <table className="table border-bottom">
                                                    <tbody>
                                                    {location.shifts.map((shift, l) => {
                                                        let max = shift.slots > shift.supporters.length ? shift.slots : shift.supporters.length;
                                                        return (Array(max).fill(1)).map((x, i) => (
                                                                <tr key={l * 10 + i}>
                                                                    <td>
                                                                        {shift.supporters[i] ? <SupporterElement supporter={shift.supporters[i]} shift={shift} location={location} route={route} supportersAvailable={tabletState.supportersAvailable} handleSupporterAvailable={() => this.props.setSupporterAvailable(shift.supporters[i])} handleSupporterCheckIn={() => this.props.checkInSupporter(shift.supporters[i], shift.id)} syncing={tabletState.syncing}/> : (
                                                                            <span>&nbsp;</span>)}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )
                                                    })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )) : null
                ) : null}
            </div>
        )
    }
}
export default translate()(TabletScreen);